// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ══════════════════════════════════════════════════════════════════
   Trinity Cut Plane — 디자인 토큰
   ------------------------------------------------------------------
   원칙
   · 색은 여기서만 정의한다. 컴포넌트 CSS 는 var() 만 쓴다.
   · 아이소메트릭은 "보여주는 화면"에만. 입력 폼·테이블은 평면 유지.
   · 3면 셰이딩 비율은 고정 — Top 1.00 / Left 0.84 / Right 0.66.
   ══════════════════════════════════════════════════════════════════ */
:root {
  /* ── 브랜드 ─────────────────────────────────────────── */
  --brand: #0f47f3;
  --brand-deep: #0a34b8;
  --brand-ink: #071e6b;
  --brand-soft: #e8eefe;
  --brand-soft-2: #d5e0fd;
  --spark: #ff6b1a;
  --spark-deep: #d9520a;
  --spark-text: #b84508;   /* orange as text — 5.9:1 on white */
  --spark-soft: #fff1e8;

  /* ── 중립 ───────────────────────────────────────────── */
  --paper: #eef1f6;
  --surface: #ffffff;
  --surface-2: #f6f8fb;
  --surface-3: #eef2f7;
  --sunk: #e1e6ee;
  --ink: #0c1118;
  --ink-2: #3f4b5c;
  --ink-3: #5f6b80;   /* 5.4:1 on white — small mono labels pass AA */
  --ink-4: #8f9aac;
  --line: #d8dee8;
  --line-2: #e8ecf2;
  --line-strong: #b9c2d0;

  /* ── 시맨틱 ─────────────────────────────────────────── */
  --ok: #0b7a34;
  --ok-soft: #e4f6ea;
  --warn: #a34f00;
  --warn-soft: #fff1e4;
  --err: #d92d20;
  --err-soft: #fdeceb;
  --info: #1160c4;
  --info-soft: #e5effb;
  --mute-soft: #eceff4;

  /* ── 아이소 3면 ─────────────────────────────────────── */
  --iso-steel-t: #e3e8ef;
  --iso-steel-l: #b9c3d1;
  --iso-steel-r: #919cad;
  --iso-iron-t: #aab4c4;
  --iso-iron-l: #838e9f;
  --iso-iron-r: #67717f;
  --iso-blue-t: #5c87ff;
  --iso-blue-l: #1b4fe8;
  --iso-blue-r: #1039ae;
  --iso-dark-t: #3b4552;
  --iso-dark-l: #29313b;
  --iso-dark-r: #1a1f27;
  --iso-paper-t: #ffffff;
  --iso-paper-l: #dfe4ec;
  --iso-paper-r: #c3cad6;
  --iso-spark-t: #ff8c4d;
  --iso-spark-l: #ff6b1a;
  --iso-spark-r: #d9520a;
  --iso-grid: #c9d0dc;
  --iso-shade: rgba(12, 17, 24, 0.14);

  /* ── 타이포 ─────────────────────────────────────────── */
  --f-d: "Urbanist", "IBM Plex Sans KR", system-ui, -apple-system, sans-serif;
  --f-b: "IBM Plex Sans", "IBM Plex Sans KR", system-ui, -apple-system, "Segoe UI", sans-serif;
  --f-m: "IBM Plex Mono", ui-monospace, "SFMono-Regular", Consolas, monospace;

  --t-h1: clamp(34px, 4.6vw, 56px);
  --t-h2: clamp(26px, 3.2vw, 38px);
  --t-h3: clamp(20px, 2.2vw, 26px);
  --t-h4: 18px;
  --t-body: 15px;
  --t-sm: 13.5px;
  --t-xs: 12px;
  --t-mono: 11px;

  /* ── 형태 ───────────────────────────────────────────── */
  --r-1: 6px;
  --r-2: 10px;
  --r-3: 14px;
  --r-4: 20px;
  --r-pill: 999px;

  --sh-1: 0 1px 2px rgba(12, 17, 24, 0.05), 0 1px 0 rgba(12, 17, 24, 0.03);
  --sh-2: 0 6px 20px -8px rgba(12, 17, 24, 0.18), 0 2px 6px rgba(12, 17, 24, 0.05);
  --sh-3: 0 20px 50px -20px rgba(12, 17, 24, 0.32), 0 8px 24px -12px rgba(12, 17, 24, 0.14);
  --sh-iso: 6px 6px 0 var(--line);
  --sh-iso-hover: 9px 9px 0 var(--line);
  --sh-iso-brand: 6px 6px 0 var(--brand-deep);
  --sh-iso-brand-hover: 9px 9px 0 var(--brand-deep);

  --ease: cubic-bezier(0.22, 0.68, 0.32, 1);
  --ease-out: cubic-bezier(0.16, 1, 0.3, 1);
  --dur: 0.18s;

  /* ── 레이아웃 ───────────────────────────────────────── */
  --wrap: 1180px;
  --wrap-narrow: 760px;
  --gutter: 28px;
  --header-h: 72px;
  --z-header: 50;
  --z-drop: 60;
  --z-modal: 100;
  --z-toast: 120;
}

@media (max-width: 640px) {
  :root {
    --gutter: 20px;
    --header-h: 64px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/tokens.css"],"names":[],"mappings":"AAAA;;;;;;;uEAOuE;AACvE;EACE,uDAAuD;EACvD,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB,IAAI,oCAAoC;EAC7D,qBAAqB;;EAErB,wDAAwD;EACxD,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB,IAAI,+CAA+C;EACnE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;;EAEtB,uDAAuD;EACvD,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,oBAAoB;;EAEpB,sDAAsD;EACtD,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,mBAAmB;EACnB,mCAAmC;;EAEnC,uDAAuD;EACvD,2EAA2E;EAC3E,4FAA4F;EAC5F,2EAA2E;;EAE3E,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,YAAY;EACZ,cAAc;EACd,cAAc;EACd,YAAY;EACZ,cAAc;;EAEd,wDAAwD;EACxD,UAAU;EACV,WAAW;EACX,WAAW;EACX,WAAW;EACX,eAAe;;EAEf,wEAAwE;EACxE,gFAAgF;EAChF,yFAAyF;EACzF,+BAA+B;EAC/B,qCAAqC;EACrC,2CAA2C;EAC3C,iDAAiD;;EAEjD,yCAAyC;EACzC,yCAAyC;EACzC,YAAY;;EAEZ,sDAAsD;EACtD,cAAc;EACd,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;EACE;IACE,cAAc;IACd,gBAAgB;EAClB;AACF","sourcesContent":["/* ══════════════════════════════════════════════════════════════════\n   Trinity Cut Plane — 디자인 토큰\n   ------------------------------------------------------------------\n   원칙\n   · 색은 여기서만 정의한다. 컴포넌트 CSS 는 var() 만 쓴다.\n   · 아이소메트릭은 \"보여주는 화면\"에만. 입력 폼·테이블은 평면 유지.\n   · 3면 셰이딩 비율은 고정 — Top 1.00 / Left 0.84 / Right 0.66.\n   ══════════════════════════════════════════════════════════════════ */\n:root {\n  /* ── 브랜드 ─────────────────────────────────────────── */\n  --brand: #0f47f3;\n  --brand-deep: #0a34b8;\n  --brand-ink: #071e6b;\n  --brand-soft: #e8eefe;\n  --brand-soft-2: #d5e0fd;\n  --spark: #ff6b1a;\n  --spark-deep: #d9520a;\n  --spark-text: #b84508;   /* orange as text — 5.9:1 on white */\n  --spark-soft: #fff1e8;\n\n  /* ── 중립 ───────────────────────────────────────────── */\n  --paper: #eef1f6;\n  --surface: #ffffff;\n  --surface-2: #f6f8fb;\n  --surface-3: #eef2f7;\n  --sunk: #e1e6ee;\n  --ink: #0c1118;\n  --ink-2: #3f4b5c;\n  --ink-3: #5f6b80;   /* 5.4:1 on white — small mono labels pass AA */\n  --ink-4: #8f9aac;\n  --line: #d8dee8;\n  --line-2: #e8ecf2;\n  --line-strong: #b9c2d0;\n\n  /* ── 시맨틱 ─────────────────────────────────────────── */\n  --ok: #0b7a34;\n  --ok-soft: #e4f6ea;\n  --warn: #a34f00;\n  --warn-soft: #fff1e4;\n  --err: #d92d20;\n  --err-soft: #fdeceb;\n  --info: #1160c4;\n  --info-soft: #e5effb;\n  --mute-soft: #eceff4;\n\n  /* ── 아이소 3면 ─────────────────────────────────────── */\n  --iso-steel-t: #e3e8ef;\n  --iso-steel-l: #b9c3d1;\n  --iso-steel-r: #919cad;\n  --iso-iron-t: #aab4c4;\n  --iso-iron-l: #838e9f;\n  --iso-iron-r: #67717f;\n  --iso-blue-t: #5c87ff;\n  --iso-blue-l: #1b4fe8;\n  --iso-blue-r: #1039ae;\n  --iso-dark-t: #3b4552;\n  --iso-dark-l: #29313b;\n  --iso-dark-r: #1a1f27;\n  --iso-paper-t: #ffffff;\n  --iso-paper-l: #dfe4ec;\n  --iso-paper-r: #c3cad6;\n  --iso-spark-t: #ff8c4d;\n  --iso-spark-l: #ff6b1a;\n  --iso-spark-r: #d9520a;\n  --iso-grid: #c9d0dc;\n  --iso-shade: rgba(12, 17, 24, 0.14);\n\n  /* ── 타이포 ─────────────────────────────────────────── */\n  --f-d: \"Urbanist\", \"IBM Plex Sans KR\", system-ui, -apple-system, sans-serif;\n  --f-b: \"IBM Plex Sans\", \"IBM Plex Sans KR\", system-ui, -apple-system, \"Segoe UI\", sans-serif;\n  --f-m: \"IBM Plex Mono\", ui-monospace, \"SFMono-Regular\", Consolas, monospace;\n\n  --t-h1: clamp(34px, 4.6vw, 56px);\n  --t-h2: clamp(26px, 3.2vw, 38px);\n  --t-h3: clamp(20px, 2.2vw, 26px);\n  --t-h4: 18px;\n  --t-body: 15px;\n  --t-sm: 13.5px;\n  --t-xs: 12px;\n  --t-mono: 11px;\n\n  /* ── 형태 ───────────────────────────────────────────── */\n  --r-1: 6px;\n  --r-2: 10px;\n  --r-3: 14px;\n  --r-4: 20px;\n  --r-pill: 999px;\n\n  --sh-1: 0 1px 2px rgba(12, 17, 24, 0.05), 0 1px 0 rgba(12, 17, 24, 0.03);\n  --sh-2: 0 6px 20px -8px rgba(12, 17, 24, 0.18), 0 2px 6px rgba(12, 17, 24, 0.05);\n  --sh-3: 0 20px 50px -20px rgba(12, 17, 24, 0.32), 0 8px 24px -12px rgba(12, 17, 24, 0.14);\n  --sh-iso: 6px 6px 0 var(--line);\n  --sh-iso-hover: 9px 9px 0 var(--line);\n  --sh-iso-brand: 6px 6px 0 var(--brand-deep);\n  --sh-iso-brand-hover: 9px 9px 0 var(--brand-deep);\n\n  --ease: cubic-bezier(0.22, 0.68, 0.32, 1);\n  --ease-out: cubic-bezier(0.16, 1, 0.3, 1);\n  --dur: 0.18s;\n\n  /* ── 레이아웃 ───────────────────────────────────────── */\n  --wrap: 1180px;\n  --wrap-narrow: 760px;\n  --gutter: 28px;\n  --header-h: 72px;\n  --z-header: 50;\n  --z-drop: 60;\n  --z-modal: 100;\n  --z-toast: 120;\n}\n\n@media (max-width: 640px) {\n  :root {\n    --gutter: 20px;\n    --header-h: 64px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
